import {
    NinchatActionType,
    NinchatUpdateIdentityAuthAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateIdentityAuth = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateIdentityAuthAction}`,
    async (arg: NinchatActionParams<NinchatUpdateIdentityAuthAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateIdentityAuthAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
